import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';

import { FindButton } from '@/components/common/Button/style';
import { EmailRow } from '@/components/common/form/formPageStyles';
import { FormActions } from '@/components/SignUp/signupStyles';

export { EmailRow };

export { FindButton };

const inlineRowBase = (theme: Theme) => css`
	display: flex;
	flex-wrap: nowrap;
	align-items: stretch;
	gap: ${theme.scale.spaceSm};
	width: 100%;

	& > div {
		flex: 1 1 0;
		min-width: 0;
		width: auto;
	}

	& > button {
		flex: 0 0 auto;
		align-self: stretch;
	}

	& > span {
		flex: 0 0 auto;
		display: inline-flex;
		align-items: center;
		align-self: stretch;
		padding: 0 0.2rem;
		font-size: ${theme.fontSize.sizeMd};
		color: ${theme.ui.text.secondary};
	}
`;

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.space2xl};
	width: 100%;
`;

export const FlexRow = styled.div`
	${({ theme }) => inlineRowBase(theme)}

	& > div:first-of-type {
		flex: 1 1 0;
	}

	@media screen and (max-width: 640px) {
		flex-wrap: wrap;

		& > div,
		& > button {
			flex: 1 1 100%;
		}
	}
`;

/** 생년월일 — 연·월·일 한 줄 */
export const BirthRow = styled.div`
	${({ theme }) => inlineRowBase(theme)}

	& > div {
		flex: 1 1 0;
		min-width: 10rem;
	}
`;

export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.spaceXl};
	width: 100%;
`;

export const GenderBox = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: ${(props) => props.theme.scale.spaceSm};
`;

export const GenderRadio = styled.label<{ $active?: boolean }>`
	display: inline-flex;
	align-items: center;
	gap: ${(props) => props.theme.scale.spacexs};
	padding: ${(props) => props.theme.scale.spaceSm} ${(props) => props.theme.scale.spaceMd};
	border: 1px solid
		${(props) => (props.$active ? props.theme.colors.primary400 : props.theme.ui.border.default)};
	border-radius: ${(props) => props.theme.effects.radiusFull};
	background: ${(props) => (props.$active ? props.theme.colors.primary50 : props.theme.ui.surface.page)};
	color: ${(props) => (props.$active ? props.theme.colors.primary400 : props.theme.ui.text.secondary)};
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	cursor: pointer;
	transition:
		border-color 0.15s ease,
		background 0.15s ease,
		color 0.15s ease;

	input {
		position: absolute;
		opacity: 0;
		width: 0;
		height: 0;
	}
`;

export const AddressBox = styled.div`
	display: flex;
	gap: ${(props) => props.theme.scale.spaceSm};
	align-items: stretch;

	@media screen and (max-width: 640px) {
		flex-direction: column;
	}
`;

export const AddressContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.spaceSm};
	width: 100%;
`;

export const Danger = styled.p`
	margin: 0;
	font-size: ${(props) => props.theme.fontSize.sizeXs};
	color: ${(props) => props.theme.colors.red600};
`;

export const Actions = styled(FormActions)``;
